module.exports = __webpack_public_path__ + "img/Invasion-LICA_PLC.c6c2e549.png";